export const maps_vector_lang={
  TH:{
    header_map:"ข้อมูลแผนที่",
    header_table:"ข้อมูลสถานที่ผู้เสียค่าธรรมเนียม",
    search:"ค้นหา",
    place_id: "รหัสที่อยู่",
    place_desc: "ที่อยู่/บ้านเลขที่",
    place_type_desc: "ชนิดที่อยู่",
    customer_name: "ชื่อผู้เสียภาษี",
    place_address: "ที่อยู่",
    fee_price:"ค่าธรรมเนียม (บาท)",
    fee_description:"ค่าธรรมเนียม (รายการ)",
    detail_zone: "รายละเอียดโซน",
    number_zone: "เลขที่โซน",
    number_block: "เลขที่บล็อค",

  },
  EN:{
    header_map:"Map",
    header_table:"Place of Customer",
    search:"Search",
    place_id: "Place id",
    place_desc: "Place Description",
    place_type_desc: "Place Type Description",
    customer_name: "Customer Name",
    place_address: "Place Address",
    fee_price:"fee price",
    fee_description:"fee description",
    detail_zone: "detail_zone",
    number_zone: "number_zone",
    number_block: "number_block",

  }
}
